export default __webpack_public_path__ + "ac807cffb18d49aa93c7346b5baff5a5.svg";